import { Badge } from "react-bootstrap";

export function BadgeDomain({ bg, children, onClick, className, size, truncateRow }) {
  const props = {
    bg,
    onClick,
  };

  return (
    <>
      <Badge style={{fontSize: size }} className={`me-1 ${truncateRow ? "truncate-row" : ""} ${onClick ? "hover-pointer" : className}`} {...props}>
        {children}
      </Badge>
    </>
  );
}
